import { render, staticRenderFns } from "./FeathersDataTable.vue?vue&type=template&id=7374c081&"
import script from "./FeathersDataTable.vue?vue&type=script&lang=js&"
export * from "./FeathersDataTable.vue?vue&type=script&lang=js&"
import style0 from "./FeathersDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports